export default {"sportsList":"rJLvs","accordion":"krG-d","accordionHeader":"K4rLG","accordionBody":"_0VjDI","category":"Zvxno"};